import React from "react";
import { Routes, Route } from "react-router-dom";
import PublicSite from "./PublicSite";
import ContactDashboard from "./MGMT/ContactDashboard";
import "./App.css";
import "./css/navigation-css.css";
import "./styles/bizmak-theme.css";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/mgmt" element={<ContactDashboard />} />
        <Route path="/" element={<PublicSite />} />
        {/* Deep links (e.g. /fedsupplier is printed on the capability statement) */}
        <Route path="*" element={<PublicSite />} />
      </Routes>
    </div>
  );
}

export default App;
